import {
  ParameterBagInterface,
  ParametersType,
} from '../../interfaces/components/dependency-injection/parameter-bag.interface';

export class ParameterBag implements ParameterBagInterface {
  private parameters: Map<string | symbol, unknown>;
  private resolved = false;

  constructor (parameters: ParametersType = {}) {
    this.parameters = new Map(Object.entries(parameters));
  }

  public get<T> (name: string | symbol): T {
    if (!this.has(name)) {
      throw new Error(`Parameter ${String(name)} not found`);
    }

    return this.parameters.get(name) as T;
  }

  public set (name: string | symbol, value: unknown): void {
    this.parameters.set(name, value);
  }

  public add (parameters: ParametersType = {}): void {
    for (const [ key, value ] of Object.entries(parameters)) {
      this.set(key, value);
    }
  }

  public remove (name: string | symbol): void {
    this.parameters.delete(name);
  }

  public has (name: string | symbol): boolean {
    return this.parameters.has(name);
  }

  public all (): ParametersType {
    return Object.fromEntries(this.parameters.entries());
  }

  public clear (): void {
    this.parameters.clear();
  }

  public resolve (): void {
    if (this.resolved) {
      return;
    }

    this.resolved = true;
  }
}
